import * as React from 'react';
import {
  accessLevelFilter,
  affiliationFilter,
  boolFilter,
  editStatusFilter,
  externalIdentifierFilter,
  formSubjectFilter,
  fundedTypeFilter,
  languageFilter,
  peerReviewStatusFilter,
  pubStatusFilter,
  pubtypeFilter,
  subjectClassifAscatypeFilter,
  subjectClassifAsjcFilter,
  subjectClassifDfgFilter,
  subjectClassifDnbFilter,
  subjectClassifKdsfFilter,
  subjectClassifOpenAlexFieldsFilter,
  subjectClassifOpenAlexSubfieldsFilter,
} from '../../Vocabulary/data';
import { QueryFacet } from '../../pages/dashboard/SearchResults';
import { FacetLabel, FacetSetting } from '../../util/types';
import { idHashFilter, facetSortByLabelDesc, facetSortByLabelAsc } from '../../pages/dashboard/utils';
import { HierarchyEntity } from '../data';

export const workFacetsSettings: FacetSetting[] = [
  {
    name: 'f_top_orga',
    label: 'search.facet.work.top_orga',
    missingLabel: 'search.facet.work.top_orga.missing',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_editorial_status',
    label: 'search.facet.work.editorial_status',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => editStatusFilter(label),
  },
  {
    name: 'f_publication_status',
    label: 'search.facet.work.publication_status',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => pubStatusFilter(label),
  },
  {
    name: 'f_publication_type',
    label: 'search.facet.work.publication_type',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => pubtypeFilter(label),
  },
  {
    name: 'f_form_subject',
    label: 'search.facet.work.form_subject',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => formSubjectFilter(label),
  },
  {
    name: 'f_issued',
    label: 'search.facet.work.issued',
    postSort: facetSortByLabelDesc,
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => label,
  },
  {
    name: 'f_person',
    label: 'search.facet.work.person',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => label,
  },
  {
    name: 'f_organisation',
    label: 'search.facet.work.organisation_person',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_project',
    label: 'search.facet.work.project_person',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.PROJECTS),
  },
  {
    name: 'f_belongs_to_organisation',
    label: 'search.facet.work.organisation_work',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.ORGS),
  },
  {
    name: 'f_belongs_to_project',
    label: 'search.facet.work.project_work',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => idHashFilter(label, HierarchyEntity.PROJECTS),
  },
  {
    name: 'f_access_level',
    label: 'search.facet.work.access_level',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => accessLevelFilter(label),
  },
  {
    name: 'f_subject_classif_dfg',
    label: 'search.facet.work.subject_classif_dfg',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifDfgFilter(label),
  },
  {
    name: 'f_subject_classif_kdsf',
    label: 'search.facet.work.subject_classif_kdsf',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifKdsfFilter(label),
  },
  {
    name: 'f_subject_classif_asjc',
    label: 'search.facet.work.subject_classif_asjc',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifAsjcFilter(label),
  },
  {
    name: 'f_subject_classif_ascatype',
    label: 'search.facet.work.subject_classif_ascatype',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifAscatypeFilter(label),
  },
  {
    name: 'f_subject_classif_openalex_fields',
    label: 'search.facet.work.subject_classif_openalex_fields',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifOpenAlexFieldsFilter(label),
  },
  {
    name: 'f_subject_classif_openalex_subfields',
    label: 'search.facet.work.subject_classif_openalex_subfields',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifOpenAlexSubfieldsFilter(label),
  },
  {
    name: 'f_subject_classif_dnb',
    label: 'search.facet.work.subject_classif_dnb',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => subjectClassifDnbFilter(label),
  },
  {
    name: 'f_oa',
    label: 'search.facet.work.oa',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => {
      const _label: string[] = label.split(' - ');
      return <>{fundedTypeFilter(_label[0].trim())} ({affiliationFilter(_label[1].trim())})</>;
    },
  },
  {
    name: 'f_language',
    label: 'search.facet.work.language',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => languageFilter(label),
  },
  {
    name: 'f_peer_reviewed',
    label: 'search.facet.work.peer_reviewed',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => peerReviewStatusFilter(label),
  },
  {
    name: 'f_hidden',
    label: 'search.facet.work.hidden',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (bool: boolean): FacetLabel => boolFilter(bool),
  },
  {
    name: 'f_external_identifier',
    label: 'search.facet.work.external_identifier',
    tristate: true,
    postSort: facetSortByLabelAsc,
    parse: (facet: QueryFacet): string => `${facet.factor === false ? '-' : ''}${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => externalIdentifierFilter(label),
  },
  {
    name: 'f_import_tenant',
    label: 'search.facet.work.import_tenant',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => label,
  },
  {
    name: 'f_origin',
    label: 'search.facet.work.origin',
    parse: (facet: QueryFacet): string => `${facet.facet}:${JSON.stringify(facet.value)}`,
    itemLabel: (label: string): FacetLabel => label,
  },
];
